import { Box, BoxProps } from "@chakra-ui/react";

export function UnloackIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00016 16.6666H15.0002V8.33325H5.00016V16.6666ZM10.0002 14.1666C10.4585 14.1666 10.8509 14.0034 11.1772 13.677C11.5036 13.3506 11.6668 12.9583 11.6668 12.4999C11.6668 12.0416 11.5036 11.6492 11.1772 11.3228C10.8509 10.9964 10.4585 10.8333 10.0002 10.8333C9.54183 10.8333 9.14947 10.9964 8.82308 11.3228C8.49669 11.6492 8.3335 12.0416 8.3335 12.4999C8.3335 12.9583 8.49669 13.3506 8.82308 13.677C9.14947 14.0034 9.54183 14.1666 10.0002 14.1666ZM5.00016 18.3333C4.54183 18.3333 4.14947 18.1701 3.82308 17.8437C3.49669 17.5173 3.3335 17.1249 3.3335 16.6666V8.33325C3.3335 7.87492 3.49669 7.48256 3.82308 7.15617C4.14947 6.82978 4.54183 6.66659 5.00016 6.66659H10.8335V4.99992C10.8335 3.84714 11.2397 2.8645 12.0522 2.052C12.8647 1.2395 13.8474 0.833252 15.0002 0.833252C16.1529 0.833252 17.1356 1.2395 17.9481 2.052C18.7606 2.8645 19.1668 3.84714 19.1668 4.99992H17.5002C17.5002 4.30547 17.2571 3.7152 16.771 3.22909C16.2849 2.74297 15.6946 2.49992 15.0002 2.49992C14.3057 2.49992 13.7154 2.74297 13.2293 3.22909C12.7432 3.7152 12.5002 4.30547 12.5002 4.99992V6.66659H15.0002C15.4585 6.66659 15.8509 6.82978 16.1772 7.15617C16.5036 7.48256 16.6668 7.87492 16.6668 8.33325V16.6666C16.6668 17.1249 16.5036 17.5173 16.1772 17.8437C15.8509 18.1701 15.4585 18.3333 15.0002 18.3333H5.00016Z"
          fill="white"
        />
      </svg>
    </Box>
  );
}
